module.exports = __webpack_public_path__ + "static/media/Z2.a9a87547.png";